import { render, staticRenderFns } from "./add-principal.vue?vue&type=template&id=57d5da6a&scoped=true"
import script from "./add-principal.vue?vue&type=script&lang=ts"
export * from "./add-principal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d5da6a",
  null
  
)

export default component.exports